import { useMemo } from "react";
import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";
import { getProfitColor } from "@utils";
import { useEstimateStructure, ValueCell } from "@tools";
import { useTheme } from "@material-ui/core/styles";

export const MaterialsCompanyProfitCell = observer((cellProps) => {
  const theme = useTheme();
  const structure = useEstimateStructure();
  
  const {
    displayCompanyBreakdownMaterialProfit,
    companyBreakdownMaterialProfitability,
    showFixedDecimalPrices,
  } = structure;
  const { currencyObj, roundPrice, priceFormat } = structure.settings;
  
  const color = useMemo(() => (
    getProfitColor(companyBreakdownMaterialProfitability, theme)
  ), [companyBreakdownMaterialProfitability, theme]);
  
  return (
    <ValueCell
      colName={ SummaryColumns.C_PROFIT }
      useDynamicWidth
      displayContent
      value={displayCompanyBreakdownMaterialProfit}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      showDecimals={!roundPrice}
      fixedDecimalScale={showFixedDecimalPrices}
      allowNegative
      applySuffixSpacing
      max={10000000}
      style={{color}}
      {...cellProps}
    />
  );
});